import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useHeaderStore from 'src/store/useHeaderStore';
import { useTranslation } from 'react-i18next';
import { useModalStore } from 'src/store/useModalStore';
import background from 'src/assets/modal_orekstadoc_background.png';

const useStyles = makeStyles(() => ({
  modalContainer: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    maxWidth: '1200px',
    height: 'auto',
    backgroundImage: `url(${background})`, // Cambia por la ruta de tu imagen
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: 'rgba(0, 0, 0, 1)', // Fondo sólido sin transparencia
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    color: 'white',
    '@media (max-width: 1200px)': {
      height: '50%',
    },
  },
  paragraph: {
    '& h6': {
      background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 'bold',
      marginBottom: '8px',
    },
    '& p': {
      margin: 0,
    },
  },
  buttonContainer: {
    marginTop: '1rem',
    display: 'flex',
    gap: '1rem',
    '@media (max-width: 1200px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  button: {
    padding: '1rem',
    color: '#fff',
    backgroundColor: '#00A8E8',
    border: '2px solid #00A8E8',
    borderRadius: '100px',
    cursor: 'pointer',
    marginBottom: '2rem',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#fff',
    },
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
}));

const ModalOrkestadoc: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const setSelectedOption = useHeaderStore((state) => state.setSelectedOption);

  const { isOpenOrkestadoc, closeModalOrkestadoc } = useModalStore();
  
  const [showModal, setShowModal] = useState(false);

  // Efecto para controlar el cierre con animación
  useEffect(() => {
    if (isOpenOrkestadoc) {
      setShowModal(true);
    } else {
      // Esperar que la animación de salida termine antes de cerrar completamente el modal
      const timer = setTimeout(() => setShowModal(false), 500); // 500ms para la animación
      return () => clearTimeout(timer); // Limpiar el timer en caso de que el modal se abra de nuevo rápidamente
    }
  }, [isOpenOrkestadoc]);
  
  return (
    <Modal open={isOpenOrkestadoc} onClose={closeModalOrkestadoc}>
      <Box className={classes.modalContainer}>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_1_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_1_DESCRIPTION')}</Typography>
        </Box>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_2_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_2_DESCRIPTION')}</Typography>
        </Box>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_3_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_3_DESCRIPTION')}</Typography>
        </Box>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_4_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_4_DESCRIPTION')}</Typography>
        </Box>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_5_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_5_DESCRIPTION')}</Typography>
        </Box>
        <Box className={classes.paragraph}>
          <Typography variant="h6">{t('ORKESTADOC_BULLET_POINT_6_TITLE')}</Typography>
          <Typography variant="body1">{t('ORKESTADOC_BULLET_POINT_6_DESCRIPTION')}</Typography>
        </Box>
        <div className={classes.buttonContainer}>
          <button className={classes.button} 
            onClick={() => {
              closeModalOrkestadoc();
              setSelectedOption('contact');
            }}
          >
            {t('QUOTE_NOW')}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalOrkestadoc;
